import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "view-wrapper" }
const _hoisted_2 = { class: "loading-panel box-shadow-transition" }
const _hoisted_3 = { class: "panel-bg" }
const _hoisted_4 = {
  key: 0,
  class: "panel-content"
}
const _hoisted_5 = { class: "item-wrapper" }
const _hoisted_6 = {
  style: {"width":"18px","height":"18px"},
  viewBox: "0 0 24 24",
  class: "icon-svg"
}
const _hoisted_7 = {
  key: 0,
  fill: "currentColor",
  d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
}
const _hoisted_8 = {
  key: 1,
  fill: "currentColor",
  d: "M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16"
}
const _hoisted_9 = {
  key: 2,
  fill: "currentColor",
  d: "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
}
const _hoisted_10 = { class: "log-item-text" }
const _hoisted_11 = {
  key: 0,
  class: "panel-title"
}
const _hoisted_12 = {
  key: 1,
  class: "item-wrapper error"
}
const _hoisted_13 = { class: "button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.state.system.loading.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "panel-title" }, " LOADING STATUS ", -1)),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.system.loading.log, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass('log-item ' + item.type),
                    key: item.text
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                      (item.type === 'success')
                        ? (_openBlock(), _createElementBlock("path", _hoisted_7))
                        : (item.type === 'warning')
                          ? (_openBlock(), _createElementBlock("path", _hoisted_8))
                          : (item.type === 'error')
                            ? (_openBlock(), _createElementBlock("path", _hoisted_9))
                            : _createCommentVNode("", true)
                    ])),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.text), 1)
                  ], 2))
                }), 128))
              ]),
              (_ctx.loadingStatus !== 'error')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " IMPORTANT NOTE "))
                : _createCommentVNode("", true),
              (_ctx.loadingStatus !== 'error')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "warning-note" }, " Any changes made to loaded characters will be lost when this tab is closed! ", -1),
                    _createElementVNode("div", { class: "warning-note" }, " If you want to keep the build - save it in your Library! ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.loadingStatus !== 'error')
                  ? (_openBlock(), _createBlock(_component_GenericButton, {
                      key: 0,
                      text: "GO TO CHARACTER",
                      class: _normalizeClass('proceed-button' + (_ctx.loadingStatus ? ' button-' + _ctx.loadingStatus : '')),
                      onClick: _ctx.goToCharacter,
                      "font-size": "22px",
                      "full-height": "",
                      "full-width": ""
                    }, null, 8, ["class", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.loadingStatus === 'warning' || _ctx.loadingStatus === 'error')
                  ? (_openBlock(), _createBlock(_component_GenericButton, {
                      key: 1,
                      text: "NEW CHARACTER",
                      class: "proceed-button",
                      onClick: _ctx.newCharacter,
                      "full-height": "",
                      "full-width": "",
                      "font-size": "24px"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}